'use client'
import { motion, type Variants } from 'framer-motion'
import { ShipperForm } from '@/components/Forms/ShipperForm'

const cardContainerVariants: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1, delayChildren: 0.1 } },
}
const cardVariants: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
}

const VALUE_PROPS = [
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth={1.5} className="text-[color:var(--accent)]" aria-hidden>
        <circle cx="16" cy="16" r="12" />
        <path d="M16 10v6l4 2" strokeLinecap="round" />
      </svg>
    ),
    title: 'Same-Day Dispatch',
    body: 'Loads covered within hours, not days. Direct contact with our dispatch team — no call centers.',
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth={1.5} className="text-[color:var(--accent)]" aria-hidden>
        <path d="M4 16h24M16 4l12 12-12 12" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: 'Northeast Specialist',
    body: 'Deep lane knowledge for NJ, NY, CT, PA, MA, MD, VA, and DE corridors. Consistent capacity on high-volume routes.',
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth={1.5} className="text-[color:var(--accent)]" aria-hidden>
        <path d="M6 24l5-5 4 4 5-7 6 8" strokeLinecap="round" strokeLinejoin="round" />
        <rect x="3" y="4" width="26" height="20" rx="2" />
      </svg>
    ),
    title: 'Real-Time Visibility',
    body: 'Live check calls and ELD-based location updates. You always know where your freight is.',
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth={1.5} className="text-[color:var(--accent)]" aria-hidden>
        <path d="M16 4l3 7h7l-5.5 4 2 7L16 18l-6.5 4 2-7L6 11h7z" strokeLinejoin="round" />
      </svg>
    ),
    title: 'Flexible Equipment',
    body: 'Dry Van, Reefer, and Power Only — Volvo and Freightliner fleet ready for your freight type.',
  },
]

export function ShippersSection() {
  return (
    <section id="shippers" className="relative overflow-hidden py-24">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: 'url(/images/careers-driver.png)' }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-[color:var(--bg-base)] opacity-90" />

      <div className="relative z-10 page-container">
        <motion.div
          className="text-center mb-14"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <p className="text-sm font-semibold tracking-widest uppercase text-[color:var(--accent)] opacity-80 mb-3">
            Direct Shipping
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight">
            Ship Direct — No Broker Required
          </h2>
          <p className="mt-4 text-white/70 text-lg max-w-2xl mx-auto leading-relaxed">
            Warehouses, manufacturers, and distributors: work directly with our fleet and eliminate the middleman markup.
          </p>
        </motion.div>

        <div className="flex flex-col lg:flex-row gap-12 items-start">
          <motion.ul
            className="flex flex-col gap-6 lg:w-1/2"
            aria-label="Why ship direct with ADG2"
            variants={cardContainerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-80px' }}
          >
            {VALUE_PROPS.map(({ icon, title, body }) => (
              <motion.li key={title} variants={cardVariants} className="glass-card rounded-2xl p-6 flex gap-5 items-start">
                <div className="shrink-0 mt-1">{icon}</div>
                <div>
                  <h3 className="text-white font-semibold text-base mb-1">{title}</h3>
                  <p className="text-white/70 text-sm leading-relaxed">{body}</p>
                </div>
              </motion.li>
            ))}
          </motion.ul>

          <div className="lg:w-1/2 w-full">
            <ShipperForm />
          </div>
        </div>
      </div>
    </section>
  )
}
